/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScheduledReportExecutionViewModel } from './scheduledReportExecutionViewModel';
import { PagedModelRequest } from './pagedModelRequest';
import { PagedListMetaData } from './pagedListMetaData';

export interface ScheduledReportExecutionViewModelPagedModelResponse {
  pagedRequest?: PagedModelRequest;
  data?: Array<ScheduledReportExecutionViewModel> | null;
  metaData?: PagedListMetaData;
}
